import script from "./SeuMentor.vue?vue&type=script&setup=true&lang=js"
export * from "./SeuMentor.vue?vue&type=script&setup=true&lang=js"

import "./SeuMentor.vue?vue&type=style&index=0&id=56826ba6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56826ba6"]])

export default __exports__